module.exports = __webpack_public_path__ + "b4e64e1d9fde23a446723dd62f2e970c.fbx";